import AboutUs from "../components/AboutUs/AboutUs";

/** Anasayfa — kısa Hakkımızda özeti; vizyon/misyon sadece /about sayfasında */
function About() {
  return (
    <div className="px-[3%] md:px-[6%]">
      <AboutUs />
    </div>
  );
}

export default About;
